import React from 'react';
import SectionLabel from './SectionLabel';

const diffPoints = [
  {
    title: 'Systems First',
    desc: 'We design the infrastructure before we build the content. Every piece of work connects to a larger system that compounds over time.',
  },
  {
    title: 'Positioning-Led',
    desc: "We start by clarifying what your brand actually stands for — then build every channel, message, and asset around that foundation.",
  },
  {
    title: 'Revenue-Connected',
    desc: "We track from visibility to conversion. Growth that doesn't connect to revenue is just activity. We build the bridge.",
  },
  {
    title: 'Selective by Design',
    desc: 'We work with a limited number of clients at any time. Every engagement receives strategic depth, not template execution.',
  },
  {
    title: 'Built for Remote',
    desc: 'Our remote growth model means serious brands anywhere can access full strategic direction, content systems, and growth infrastructure.',
  },
];

const Difference: React.FC = () => (
  <section
    id="difference"
    className="relative py-[120px] px-10"
    style={{ background: 'linear-gradient(200deg, #131210 0%, #0d0c0b 100%)' }}
  >
    <div
      className="absolute inset-0 pointer-events-none"
      style={{ background: 'radial-gradient(ellipse 45% 65% at 8% 75%, rgba(184,154,90,0.025) 0%, transparent 58%)' }}
    />
    <div className="max-w-[1200px] mx-auto relative z-10">
      <SectionLabel>What Makes HNL Different</SectionLabel>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-24 mt-16 items-start">
        {/* Left */}
        <div className="fade-up">
          <blockquote
            style={{
              fontFamily: '"Cormorant Garamond", Georgia, serif',
              fontSize: 'clamp(22px, 2.8vw, 32px)',
              fontWeight: 300,
              fontStyle: 'italic',
              color: '#f2ece0',
              lineHeight: 1.5,
              borderLeft: '2px solid #b89a5a',
              paddingLeft: 28,
              marginBottom: 40,
            }}
          >
            "Most agencies sell execution. We build the architecture that makes execution work."
          </blockquote>
          {[
            'HNL Digital Luxe was built from a precise observation: the brands struggling with growth are not short on content or ad spend. They are short on structure — clear positioning, coherent systems, and the infrastructure that turns visibility into revenue.',
            'We are not a content factory. We are a strategic growth firm. We work upstream — at the level of brand positioning, system design, and operational architecture — before we touch execution.',
            "That distinction is why our clients don't just look better. They grow.",
          ].map((p, i) => (
            <p key={i} style={{ fontSize: 13, color: '#aea89f', lineHeight: 2.1, marginBottom: 16, letterSpacing: '0.02em' }}>
              {p}
            </p>
          ))}
        </div>
        {/* Right */}
        <div>
          {diffPoints.map((pt, i) => (
            <div
              key={pt.title}
              className="fade-up py-7"
              style={{
                borderBottom: '1px solid rgba(184,154,90,0.08)',
                borderTop: i === 0 ? '1px solid rgba(184,154,90,0.08)' : undefined,
              }}
            >
              <h4 style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#b89a5a', marginBottom: 8, fontFamily: 'Montserrat, sans-serif' }}>
                {pt.title}
              </h4>
              <p style={{ fontSize: 13, fontWeight: 300, color: '#aea89f', lineHeight: 1.8 }}>{pt.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Difference;
